import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/core";
import { get, size, map, filter, sortBy } from "lodash";
import TableRow from "@material-ui/core/TableRow";

import TableCellStyled from "../../Common/TableCellStyled";
import ScrollableTable from "../../Common/Table/ScrollableTable";
import TemperatureMetricsTableRow from "./TemperatureMetricsTableRow";

const columns = [
  {
    minWidth: 30,
  },
  {
    name: "site_chrono",
    minWidth: 100,
  },
  {
    name: "site_createdByOn",
    minWidth: 200,
  },
  {
    name: "profiles_photo",
    minWidth: 80,
  },
  {
    name: "site_tempType",
    minWidth: 115,
  },
  {
    name: "site_manualTemp2",
    minWidth: 100,
  },
  {
    name: "site_kioskAvgTemp",
    minWidth: 100,
  },
  {
    name: "site_kioskMinTemp",
    minWidth: 100,
  },
  {
    name: "site_kioskMaxTemp",
    minWidth: 100,
  },
];

const styles = {
  archivedCell: {
    fontWeight: "500",
    paddingTop: "30px !important",
  },
};

const excludeAttr = [153, 164, 165, 166, 167, 168, 88, 187];

const TemperatureMetricsTable = (props) => {
  const {
    classes,
    language,
    data,
    showAllColumns,
    lov,
    startTime,
    setFocusPhotoEvent,
    refresh,
  } = props;

  const allColumns = [
    ...columns,
    {
      name: "profiles_eventId",
      minWidth: 200,
    },
    ...map(
      sortBy(
        filter(
          get(props, ["data", "events", 0, "attributes"]),
          (attr) => !excludeAttr.includes(attr.id)
        ),
        (attr) => get(attr, ["app_display_seq_numb"])
      ),
      (attr) => ({
        name: get(attr, [`name_${language}`]),
        id: attr.id,
      })
    ),
  ];

  return (
    <>
      <ScrollableTable
        columns={showAllColumns ? allColumns : columns}
        hasMore={false}
        stickyHeader
      >
        {map(
          sortBy(
            filter(
              get(data, ["events"]),
              (e) => get(e, ["type", "id"]) === 82 && get(e, ["active"])
            ),
            (e) => e.created_on
          ),
          (item, index) => (
            <TemperatureMetricsTableRow
              key={item.id}
              item={item}
              eventGroup={get(data, ["id"])}
              index={index}
              language={language}
              lov={lov}
              startTime={startTime}
              showAllColumns={showAllColumns}
              setFocusPhotoEvent={setFocusPhotoEvent}
              refresh={refresh}
            />
          )
        )}
        {size(
          filter(
            get(data, ["events"]),
            (e) => get(e, ["type", "id"]) === 82 && !get(e, ["active"])
          )
        ) > 0 && (
            <>
              <TableRow>
                <TableCellStyled
                  className={classes.archivedCell}
                  colSpan={size(showAllColumns ? allColumns : columns)}
                >
                  {I18n.get("site_archivedTemperatures")}
                </TableCellStyled>
              </TableRow>
              {map(
                sortBy(
                  filter(
                    get(data, ["events"]),
                    (e) => get(e, ["type", "id"]) === 82 && !get(e, ["active"])
                  ),
                  (e) => e.created_on
                ),
                (item, index) => (
                  <TemperatureMetricsTableRow
                    key={item.id}
                    item={item}
                    eventGroup={get(data, ["id"])}
                    index={index}
                    language={language}
                    lov={lov}
                    startTime={startTime}
                    showAllColumns={showAllColumns}
                    setFocusPhotoEvent={setFocusPhotoEvent}
                    refresh={refresh}
                    archived
                  />
                )
              )}
            </>
          )}
      </ScrollableTable>
    </>
  );
};

export default withStyles(styles)(TemperatureMetricsTable);
